/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MailboxIcon = ({ width = 24, height = 24, hidden = false, title = 'Mailbox' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M5 8a5 5 0 0 0-5 5v16a1 1 0 0 0 1 1h11V13a5 5 0 0 0-5-5ZM31 8H18v7a1 1 0 0 1-1 1h-3v14h21a1 1 0 0 0 1-1V13a5 5 0 0 0-5-5Z"
    />
    <path d="M21 0h-6a1 1 0 0 0-1 1v13h2V6h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z" />
  </svg>`;
};
